import { API_URL } from '../../../../../utils/config';

export const MAKE_REFUND_REQUEST_URL = `${API_URL}/refund`;
export const SEND_REFUND_EMAIL_NOTIFICATION = `${API_URL}/notification/FSEmgrRefundMail`;
export const SEARCH_REFUND_REQUEST_URL = `${API_URL}/refund/search`;
export const GET_REFUND_REQUEST_URL = `${API_URL}/refund/search`;
export const CHECK_AVAILABLE_DATES_URL = `${API_URL}/checkavailabledate`;
export const UPDATE_REFUND_URL = `${API_URL}/refund/update`;
export const BULK_UPDATE_REFUND_URL = `${API_URL}/refund/bulkaccountrefundupdate`;
